import { IMouseLogModule, IMouseLogData } from './types'
import { ModuleID } from '../types'

import Mus from '../../lib/mus.js'

const SCHEMA_VERSION = 'v2'

const mus = new Mus()
let started = false
let firstFrame: IMouseLogData | null = null

function fmt(n: number) {
  return n < 0 ? `${n}` : `,${n}`
}

function compressEvents(events: IMouseLogData[]): string {
  if (!events || events.length === 0) {
    return ''
  }

  const prev = { x: 0, y: 0, k: 0, t: 0 }

  return (
    SCHEMA_VERSION +
    ':' +
    events
      .map(event => {
        const t = Math.round(event.time ?? 0)

        if (event.x != null) {
          const x = Math.round(event.x)
          const y = Math.round(event.y ?? 0)
          const dx = x - prev.x
          const dy = y - prev.y
          const dt = t - prev.t

          prev.x = x
          prev.y = y
          prev.t = t
          if (event.type === 'i') {
            prev.t = 0
            return `${event.type}${dx}${fmt(dy)}${fmt(t)}${fmt(event.touch ? 1 : 0)}`
          }
          return `${event.type}${dx}${fmt(dy)}${fmt(dt)}`
        }

        if (event.keyCode != null) {
          const k = event.keyCode
          const dk = k - prev.k
          const dt = t - prev.t

          prev.k = k
          prev.t = t
          return `${event.type}${dk}${fmt(dt)}`
        }

        return ''
      })
      .join('')
  )
}

const MouseLogModule: IMouseLogModule = {
  get id() {
    return ModuleID.MOUSE_LOG
  },
  config() {
    return MouseLogModule
  },
  load() {
    return Promise.resolve(MouseLogModule)
  },
  get loaded() {
    return true
  },
  start() {
    if (started) return
    started = true
    mus.setTimePoint(true)
    mus.record()
    firstFrame = {
      type: 'i',
      x: window.outerWidth,
      y: window.outerHeight,
      touch: window.matchMedia('(pointer: coarse)').matches,
      time: Date.now()
    }
  },
  getData() {
    const validTypes = ['m', 'c', 's', 'k', 'p', 't']
    const result: IMouseLogData[] = mus
      .getData()
      .frames.filter((frame: unknown[]): boolean => Array.isArray(frame) && validTypes.includes(frame[0] as string))
      .map((frame: unknown[]): IMouseLogData => {
        if (frame[0] === 'k') {
          return {
            type: frame[0] as string,
            keyCode: frame[1] as number,
            time: frame[2] as number
          }
        }
        return {
          type: frame[0] as string,
          x: frame[1] as number,
          y: frame[2] as number,
          time: frame[3] as number
        }
      })
    if (firstFrame) {
      result.unshift(firstFrame)
      firstFrame = null
    }
    mus.setFrames([])
    mus.record()

    return compressEvents(result)
  }
}

export default MouseLogModule
